<template>
  <v-row dense no-gutters>
    <v-col cols="8">
      <m-u-local-table :value="selectedMU" @input="onMUChange"/>
    </v-col>
    <v-col cols="4">
      <ref-m-u-card :MU="selectedMU.length ? selectedMU[0] : {}" mode="viewer"/>
    </v-col>
    <ref-add-m-u-dialog :MU="selectedMU.length ? selectedMU[0] : {}" v-model="showAddMUDialog" @MUAdded="onMUAdded" @MUUpdate="onMUUpdated"/>
    <sys-confirm-dialog :value="showDelConfirmDialog" :message="'Подтвердите удаление'" :no-call-back="cancelConfirmDialog" :ok-call-back="doDeleteFT"/>
  </v-row>
</template>

<script>
import MULocalTable from '@/components/modules/references/refMULocalTable'
import RefMUCard from '@/components/modules/references/cards/refMUCard'
import { UI_ADD_ACTION, UI_SET_ACTIONS, UI_SNACKBAR } from '@/store/actions/ui'
import RefAddMUDialog from '@/components/modules/references/dialogs/refAddMUDialog'
import SysConfirmDialog from '@/components/common/dialogs/confirmDialog'
import axios from 'axios'
export default {
  name: 'MULocalList',
  props: ['accessKey'],
  components: { SysConfirmDialog, RefAddMUDialog, RefMUCard, MULocalTable },
  data () {
    return {
      addAction: { text: 'Добавить ЕИ', actionType: 'Локальные ЕИ', action: 'addMU', method: this.addMU, icon: 'mdi-database-plus' },
      updAction: { text: 'Редактировать ЕИ', actionType: 'Локальные ЕИ', action: 'updMU', method: this.updateMU, icon: 'mdi-database-edit' },
      delAction: { text: 'Удалить ЕИ', actionType: 'Локальные ЕИ', action: 'delMU', method: this.delMU, icon: 'mdi-database-minus' },
      selectedMU: [],
      showAddMUDialog: false,
      showDelConfirmDialog: false
    }
  },
  watch: {
    accessKey (val) {
      console.log('Called for accessKey ', val)
      if (val !== 'forms/refMULocalList') {
        this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Локальные ЕИ' })
      } else {
        this.setActions()
      }
    }
  },
  methods: {
    setActions () {
      this.$store.dispatch(UI_SET_ACTIONS, { actionType: 'Локальные ЕИ' })
      this.$store.dispatch(UI_ADD_ACTION, this.addAction)
      if (this.selectedMU.length) {
        this.$store.dispatch(UI_ADD_ACTION, this.updAction)
        this.$store.dispatch(UI_ADD_ACTION, this.delAction)
      }
    },
    addMU () {
      this.selectedMU.splice(0, 1)
      this.showAddMUDialog = true
    },
    updateMU () {
      this.showAddMUDialog = true
    },
    delMU () {
      this.showDelConfirmDialog = true
    },
    onMUChange (item) {
      this.selectedMU.splice(0, 1, ...item)
      this.setActions()
    },
    onMUAdded (data) {
      this.onMUChange(data)
      this.showAddMUDialog = false
    },
    onMUUpdated (data) {
      this.onMUChange(data)
      this.showAddMUDialog = false
    },
    cancelConfirmDialog () {
      this.showDelConfirmDialog = false
    },
    doDeleteFT () {
      this.showDelConfirmDialog = false
      const processorPath = '/api/org/references/delMU.php'
      const payload = { ...this.selectedMU[0] }
      axios({
        url: processorPath,
        method: 'POST',
        data: payload
      })
        .then(resp => {
          if (resp.data.error === 'ok') {
            this.selectedMU.splice(0, 1, { action: 'delete', EI_ID: this.selectedMU[0].EI_ID })
          } else {
            this.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${resp.data.error_text}` })
          }
        })
        .catch((err) => {
          self.$store.commit(UI_SNACKBAR, { color: 'red darken-1', text: `Ошибка: \n ${err}` })
        })
    }
  },

  mounted () {
    console.log('Local measuring units module mounted')
    this.setActions()
  }
}
</script>

<style scoped>

</style>
